import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMileageinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.125,
			d: "M15.75 12.375V15a.75.75 0 0 1-.75.75h-1.5a.75.75 0 0 1-.75-.75v-1.125m-7.5 0V15a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-2.625"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.125,
			d: "M2.25 12.375v-2.066c0-.597.237-1.17.66-1.592l.84-.842h10.5l.84.84a2.25 2.25 0 0 1 .66 1.592v2.068a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.125,
			d: "m15.75 7.125-1.5.375m-10.5 0-1.5-.375m1.5.75v-.38l.627-2.352A1.876 1.876 0 0 1 6.19 3.75h5.686c.869 0 1.623.596 1.824 1.44l.55 2.305v.38m-9.75 3H6m6 0h1.5"
		})
	]
});
export default SvgMileageinline;
